<nav class="navbar navbar-expand-lg navbar-absolute fixed-top">
    <div class="container-fluid">
        <div class="navbar-wrapper" style="height: 85px; width:85%;">
            <img style="width:200px; margin-left:180px" src="/assets/svg/lndr-logo-reverse.svg" />
            <div class="collapse navbar-collapse justify-content-end" style="width:85%" id="navigation">
            </div>
        </div>
    </div>
</nav>